/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./radio-group-form-item.vue?vue&type=template&id=2efb8732&"
import script from "./radio-group-form-item.vue?vue&type=script&lang=js&"
export * from "./radio-group-form-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports